export class DocumentProofType {
  id!: number;
  name!: string;
  description!: string;
  created_at:  Date = new Date();
  updated_at:  Date = new Date();
}
